
const INITIAL_STATE = {
    open: false,
};

export default function(state = INITIAL_STATE, action) {
    switch(action.type) {
        case "SHOW_MENU":
            return {open: true};
        case "HIDE_MENU":
            return {open: false};
        case "TOGGLE_MENU":
            return {open: !state.open};
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/store/reducers/menu.js